<template>
  <div class="personalMain">
    <p class="current">当前位置：<span>个人中心</span><i class="el-icon-arrow-right"></i><span>购物车</span></p>
    <div class="personal-box">
      <personalMenu></personalMenu>
      <div class="MainInfo">
        <div class="cartTop" v-show="cartList != ''">
          <p class="title">购物车</p>
        </div>
        <div v-show="cartList == ''" class="cartNull">
            <p>亲，您的购物车为空~</p>
            <el-button round @click="HandleProducts">去逛逛</el-button>
          </div>
        <div class="mySin-context">
          <el-checkbox-group v-model="checkedCities">
            <div v-for="item in cartList" :key='item.id' class="list-Item">
              <div class="Item-left">
                <el-checkbox :label="item" :disabled="item.amount < item.min_amount " @change="(value,) => {handleCheckedCitiesChange(value,item)}">{{  }}</el-checkbox>
                <div :style="'background-image:url('+item.firstFile.FileUrl+');background-size: cover;background-repeat: no-repeat;background-position: center;width: 90px;height: 62px;margin-left: 10px'"></div>
                <div class="left-font">
                  <p>{{item.product_name}}</p>
                  <span>￥{{item.price}}</span>
                  <br>
                  <span v-if="item.atts_items_names == ',' || !item.atts_items_names == ''" style="font-size: 16px;color: #666666;font-weight: 300;">已选购 {{item.atts_items_names}}</span>
                </div>
              </div>
              <div class="Item-right">
                <el-input-number v-model="item.amount" :step="1"   @change="(currentValue, oldValue,)=>{getNum(currentValue, oldValue,item)}"></el-input-number>
                <p class="tipSpan">
                  <span style="color: #999999;">最低起购{{item.min_amount}}{{ item.unit }}</span>
                  <span style="cursor: pointer;margin-left: 15px;" @click="HandleDelete(item)">删除</span>
                </p>
              </div>
            </div>
          </el-checkbox-group>
        </div>
        <div class="priceBottom">
          <div class="priceBox" >
            <div class="checkedDiv">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" v-if="cartList != ''">全选</el-checkbox>
              
            </div>
            <div class="price-Button">
              <!-- <p v-show="checkedCities.length == 0">商品总额：<span style="font-size: 14px;">￥</span><span>{{ num }}</span></p> -->
              <p>已选商品总额：<span style="font-size: 14px;">￥</span><span>{{ num }}</span></p>
              <!-- <p v-show="checkedCities.length == 0">商品总额：<span style="font-size: 14px;">￥</span><span>{{ num }}</span></p>
              <p v-show="checkedCities.length != 0">已选中 <span color="#4095e5">{{ sum }}</span> 件，应付<span style="font-size: 18px;">￥</span><span>{{ checkedNum }}</span></p> -->
              <!-- <el-button @click="IsShare = 1">分享</el-button> -->
              <el-dropdown trigger="click">
                  <div style="font-size: 16px;background-color: #ffffff;padding: 8px 17px;border: 1.5px solid #DCDFE6;margin-right: 10px;cursor: pointer;" @click="HandleShare">
                      <!-- <i class="el-icon-share"></i> -->
                      分享
                  </div>
                  <el-dropdown-menu slot="dropdown">
                      <div style="padding: 10px 20px;" v-if="isCode">
                          <share :config="config"></share>
                      </div>
                      <!-- <el-dropdown-item command="1">微信</el-dropdown-item>
                      <el-dropdown-item command="2">微博</el-dropdown-item>
                      <el-dropdown-item command="3">QQ</el-dropdown-item>
                      <el-dropdown-item command="4">QQ空间</el-dropdown-item> -->
                  </el-dropdown-menu>
              </el-dropdown>
              <el-button @click="handleDeleteTwo()">删除</el-button>
              <el-button>批量下单</el-button>
              <el-button @click="formatJson">导出商品</el-button>
              <!-- <el-button v-print="printObj">导出报价单</el-button> -->
              <!-- <el-button @click="getPdf()">导出报价单</el-button> -->
              <el-button @click="formatJsonPopup">导出报价单</el-button>
              <el-button type="primary" @click="getSettlement" :disabled="checkedCities.length == 0">去结算</el-button>
            </div>
          </div>
          
          

        </div>
      </div>
      
    </div>
    <div  v-show="popup"   class="login">
     <div id="pdfDom" >
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <img src="../../assets/headerLogo.png" alt="" width="230px">
          <h1 style="font-size:22px;">企链工报价单</h1>
          <p style="font-size:18px;margin-right: 10px;">400-800-4059</p>
        </div>
        <!-- <div class="descInfo">
          <el-descriptions>
            <el-descriptions-item label="询价客户">xunjiakehu</el-descriptions-item>
            <el-descriptions-item label="报价单位">苏州市</el-descriptions-item>
            <el-descriptions-item label="报价单号">12434356</el-descriptions-item>

            <el-descriptions-item label="客户编码">kehuming</el-descriptions-item>
            <el-descriptions-item label="电话">18100000000</el-descriptions-item>
            <el-descriptions-item label="客服经理">nihoa</el-descriptions-item>

            <el-descriptions-item label="联系人">xunjiakehu</el-descriptions-item>
            <el-descriptions-item label="地址">苏州市</el-descriptions-item>
            <el-descriptions-item label="客服代表">12434356</el-descriptions-item>

            <el-descriptions-item label="电话">kehuming</el-descriptions-item>
            <el-descriptions-item label="开户银行">18100000000</el-descriptions-item>
            <el-descriptions-item label="客服电话">nihoa</el-descriptions-item>

            <el-descriptions-item label="传真">xunjiakehu</el-descriptions-item>
            <el-descriptions-item label="账号">苏州市</el-descriptions-item>
            <el-descriptions-item label="销售电话">12434356</el-descriptions-item>

            <el-descriptions-item label="付款方式">kehuming</el-descriptions-item>
            <el-descriptions-item label="发运方式">18100000000</el-descriptions-item>
          </el-descriptions>
        </div> -->
        <div class="descInfo">
          <el-table
            border
            :data="tableData"
           > 
         
            <el-table-column
              type="index"
              label="序号"
              >
            </el-table-column>
            <el-table-column
              prop="customerMaterial"
              label="客户物料号"
              >
            </el-table-column>
            <el-table-column
              prop="sku"
              label="SKU编码"
              >
            </el-table-column>
            <el-table-column
              prop="brand"
              label="品牌"
             >
            </el-table-column>
            <el-table-column
              prop="pcode"
              label="编码型号"
              >
            </el-table-column>
            <el-table-column
              prop="unit"
              label="单位"
              >
            </el-table-column>
            <el-table-column
              prop="min_amount"
              label="订量要求"
             >
            </el-table-column>
            <el-table-column
              prop="price"
              label="含税单价"
             >
            </el-table-column>
            <el-table-column
              prop="taxRate"
              label="税率"
             >
            </el-table-column>
            <el-table-column
              prop="amount"
              label="数量"
              >
            </el-table-column>
            <el-table-column
              prop="priceNum"
              label="含税小计"
             >
            </el-table-column>
            <el-table-column
              prop="delivery"
              label="发货日"
              >
            </el-table-column>
            <el-table-column
              prop="quotationDate"
              label="报价日期"
              >
            </el-table-column>
            <el-table-column
              prop="requirement"
              label="需求描述"
             >
            </el-table-column>
          </el-table>
          <div style="text-align: right;font-size: 14px;">
            <!-- 未税总额： ￥539.22  -->
            含税总额￥{{ numPopup }}
          </div>
        </div>
        <div style="font-size: 14px;display: flex;justify-content: flex-start;">
          <div style="width: 60%;">
            <p>特别说明：</p>
            <p>改上价格仅为产品价格(不包含促销优惠及积分抵扣)，若需安装/调试/培训等服务请咨询客服部。
此报价单有效期为90天，有其他有效期备注的以备注为准，产品价格、交货期及可销售数量以正式订单确认的信息为准。</p>
            <p style="color: red;">【发货日】栏的产品库存(若有)仅指当前库存，存在随时变动可能，建议尽早下单。</p>
            <p style="margin-top: 20px;">运费说明：</p>
            <p>1、普通商品单笔订单(不含特殊类商品和其他非实物商品)含税应付金额满300元免运费，
不满300元，普通地区收取基础运费8元/单，偏远地区收取基础运费50元/单:详见www.qlg360.com帮助中心运费政策</p>
            <p>2、订单含税应付金额为除去积分抵扣与优惠金额后的订单金额。</p>
          
          </div>
          <div style="margin-top: 50px;margin-left: 30px;">
            <p>卖方：企链工</p>
          </div>
        </div>
     </div>
     <div class="pdfButton">
        <el-button type="primary"  @click="getPdf()">导出</el-button>
        <el-button type="primary"  @click="popup = 0">取消</el-button>
     </div>
    </div>

    <div v-show="IsShare" class="login">
      <share :config="config"></share>
      <div class="pdfButton">
        <el-button type="primary"  @click="IsShare = 0">取消</el-button>
     </div>
    </div>
  </div>
</template>

<script>
import personalMenu from './index.vue'
export default {
  data(){
    return{
      shareCode: '',
      tableData: [],
      idList: [],
      numPopup: 0,
      num: 0,
      checkedNum: 0,
      sum: 0,
      cartList: [],
      checkedCities: [],
      checkAll: false,
      isIndeterminate: false,
      excelName: '购物车商品列表',
      printObj: {
        id: 'printMe',
        popTitle: '企链工报价打印'
      },
      htmlTitle: '企链工报价打印PDF',
      popup: 0,
     
      config:{
          sites: ['qq','wechat'],
          url: '',
          title: '购物车',
          wechatQrcodeTitle   : '微信扫一扫：分享',
          wechatQrcodeHelper  : '<p>扫一扫</p><p>二维码便可将本文分享至朋友圈。</p>'
      },
      IsShare: 0,
      intI: 0,
      isCode: false
    }
  },
  components:{
    personalMenu
  },
  methods: {
    HandleShare(){
      let listId = ''
        this.idList.forEach((item,index) => {
          if(index == 0){
            listId = item
          }else{
            listId = listId + ',' + item
          }
        });
      let data = {
        ids: listId
      }
      this.isCode = false
      this.$store.dispatch('personal/orderShare',data)
        .then(res => {
          if(res.ok){
            this.shareCode = res.data
            this.$nextTick(() =>{
              this.config.url = 'http://h5.qlg360.com/#/pages/cart/cartSharing?skcode='+res.data

              this.isCode = true
            })
          }else{
            this.$notify({
              title: '提示',
              message: '未选择分享的商品',
              type: 'error'
            })
          }
        })
    },
    HandleDelete(item){
      console.log(item);
      let data = {
        ids: JSON.stringify(item.id)
      }
      
      this.$confirm('要删除该项吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.Hdelete(data)
        
        }).catch(() => {
          this.$notify({
            title:'提示',
            message: '已取消删除',
            type: 'info'
          })   
        });
    },
    handleDeleteTwo(){
      if(this.checkedCities.length != 0){
        this.$confirm('要删除该项吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          let listId = ''
          this.checkedCities.forEach((item,index) => {
              if(index == 0){
                listId = item.id
              }else{
                listId = listId + ',' + item.id
              }
          });

          let data = {
            // ids : JSON.stringify(listId)
            ids : listId
          }

          this.Hdelete(data)
        }).catch(() => {
          this.$notify({
            title:'提示',
            message: '已取消删除',
            type: 'info'
          })         
        });
          
      }else{
        this.$notify({
              title: '提示',
              message: '请选择需要删除的商品',
              type: 'error'
          });
      }
    },
    Hdelete(data){
      this.$store.dispatch('personal/deleteCard',data)
          .then(res => {
              if(res.ok){
                this.$notify({
                  title: '提示',
                  message: '删除成功',
                  type: 'success'
                });
                this.list()
              }
          })
    },
    handleExportSuccess() {
      console.log("?????????????????//");
      this.loading = false;
      document.removeEventListener('export_success', this.handleExportSuccess);
      return 'nihao'
    },
    formatJson(){
      if(this.checkedCities.length != 0){
        let list = []
        this.checkedCities.forEach(item => {
          if(item.amount >= item.min_amount){
            list.push(item)
          }
        });
        if(list.length == 0){
          this.$notify({
              title: '提示',
              message: '购买数据少于最低起购量，不能导出',
              type: 'error'
          });
        }else{
          const th = ['产品名称','产品规格','订货编号','规格产品编码', '制造厂商','单价','单位','起订量要求','数量']

          const filterVal = ['product_name','atts_items_names','pcode','sku_code','company_name','price','unit','min_amount','amount',]
          const data = list.map(v =>filterVal.map(k => v[k] ))
          
          const [fileName, fileType, sheetName, autoWidth] = [this.excelName, 'xlsx', this.excelName, true]

          this.$toExcel({th, data, fileName, fileType, sheetName, autoWidth})
        }
       
        
      
      }else{
        this.$notify({
              title: '提示',
              message: '请选择需要导出的商品',
              type: 'error'
          });
      }
    },
    formatJsonPopup(){
      if(this.checkedCities.length != 0){
        this.popup = 1
        
        console.log(this.checkedCities);
        this.numPopup  = 0
        this.checkedCities.forEach(item => {
          this.numPopup = this.numPopup + item.price * item.amount 
          var lists = {
            customerMaterial: '', // 客户物料号
            sku: '', // sku编码
            brand: '', // 品牌
            pcode: item.pcode,// 编码型号
            unit: item.unit, // 单位
            min_amount: item.min_amount,// 订量要求
            price: item.price,// 含税单价
            taxRate: '',// 税率
            amount: item.amount,// 数量
            priceNum: (item.amount * item.price).toFixed(2),// 含税小计
            delivery: '',// 发货日
            quotationDate: '',// 报价日期
            requirement: ''// 需求描述
          }
          
          this.$nextTick(() => {
            this.tableData.push(lists);
          })
        })
        this.numPopup = this.numPopup.toFixed(2)
        
      }else{
        this.$notify({
              title: '提示',
              message: '请选择需要导出的商品',
              type: 'error'
          });
      }
    },
    handleCheckAllChange(val) {
      console.log(val);
      this.idList = []
      if(val){
        this.checkedCities = []
        this.cartList.forEach(item => {
            this.checkedCities.push(item)
            this.num = this.num + item.amount * item.price

            this.idList.push(item.id)
        });
        this.num = parseFloat(this.num).toFixed(2)
        this.checkedNum = 0
        this.sum = 0
        this.checkedCities.forEach(item => {
          this.checkedNum = this.checkedNum + item.price * item.amount 
          this.sum = this.sum + item.amount
        });
       
      }else{
        this.checkedNum = 0
        this.sum = 0
        this.checkedCities = []
      }
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value,item) {
      console.log(value);
      console.log(item);
      this.intI = this.checkedCities.length
      console.log(this.intI);
      if(value){
        this.idList.push(item.id)
        
        
        if(this.intI == 1){
          this.num = item.amount * item.price
        }else if(this.intI > 1){
          this.num = 0
          this.checkedCities.forEach(val => {
            this.num = this.num + val.amount * val.price
          });
          console.log(this.num);
          
        }
        this.checkedNum = 0
        this.sum = 0
        this.checkedCities.forEach(item => {
          this.checkedNum = this.checkedNum + item.price * item.amount 
          this.sum = this.sum + item.amount
        });
        let checkedCount = this.checkedCities.length;
        this.checkAll = checkedCount == this.cartList.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.cartList.length;
        
      }else{
        this.idList.forEach((val,index) => {
          if(val == item.id){
            this.idList.splice(index,1)
          }
        });
        if(this.intI == 0){
          this.num = 0
         
            // this.num = this.num.toFixed(2)
            
        }else{
          this.num = this.num - item.price * item.amount
        }
        
      }

      this.num = parseFloat(this.num).toFixed(2)
      
    },
    getNum(currentValue, oldValue, item){
      console.log(currentValue);
      console.log(oldValue);
      console.log(item);
      if(currentValue == 0){
        this.$confirm('要删除该项吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
       
          this.updateSelf(currentValue, item)
          
        }).catch(() => {
            item.amount = 1
        });
      }else{ 
        // this.num = 0
        // this.cartList.forEach(item => {
        //     this.num = this.num+item.price*item.amount
        // });
        this.updateSelf(currentValue, item)
      }
    },
    updateSelf(currentValue, item){
      let data = {
        amount: currentValue,
        id: item.id,
        product_id: item.product_id,

      }
      this.$store.dispatch('personal/updateSelf',data)
        .then(res => {
          
          if(res.ok){
            this.num  = 0
            this.cartList.forEach((item,index) => {
                this.num = this.num + item.price * item.amount 

                if(item.amount == 0){
                    this.cartList.splice(index,1)
                }
            });
            // this.num = this.num.toFixed(2)
            this.num = parseFloat(this.num).toFixed(2)
            this.list()
          }
        })
    },
    list(){
      let data = {
        order_no: '888888',
        product_type: 'product',
      }
      this.num = 0
      this.checkedCities = []
      this.$store.dispatch('personal/list',data)
        .then(res => {
          if(res.ok){
            this.cartList = res.data.items
            this.cartList.forEach(item => {
                let i = item.price * item.amount 
                this.num = this.num + i
                this.checkedCities.push(item)
            });
            // this.num = this.num.toFixed(2)
            this.num = parseFloat(this.num).toFixed(2)
            console.log(this.checkedCities);
          }
        })
      },
      HandleProducts(){
        const { href } = this.$router.resolve({
          path: "/products"
        });
        window.open(href, '_blank');
      },
      getSettlement(){
        let listId = ''
        this.idList.forEach((item,index) => {
          if(index == 0){
            listId = item
          }else{
            listId = listId + ',' + item
          }
        });
        this.$router.push({
          path: '/checkoutQuick',
          query: {
              ids: listId
          }
        })
      }
   
  },
  mounted(){
    localStorage.setItem('active','2-3')
    this.list()
  }
}
</script>


<style scoped lang="scss">
@import url(../../css/personal.css);
.cartTop .title{
  font-size: 22px;
  /* margin-bottom: 40px; */
}
.priceBottom{
  width: 96%;
  margin: 0px auto;
  position: absolute;
  bottom: 10px;
  left: 2%;
}
.priceBottom .priceBox {
  padding: 10px 10px;
  background: rgba(242, 242, 242, 0.4);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
 
}

.priceBottom .priceBox span{
  font-size: 22px;
  font-weight: 700;
  color: #4095e5;
  /* margin-left: 10px; */
}
.priceBottom .priceBox .el-button{
  border-radius: 0;
}

.price-Button{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.price-Button p{
  margin-right: 10px;
}
::v-deep .price-Button .el-checkbox{
  padding-top: 5px;
}
.checkedDiv p{
  margin-left: 10px;
  font-size: 14px;
}
.mySin-context{
  margin-top: 20px;
  padding-bottom: 60px;
}

.cartTop{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
  }
.Item-left{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.Item-left .left-font{
  margin-left: 20px;
  font-size: 19px;
}
.Item-left .left-font p{
  margin-bottom: 10px;
}
.Item-left .left-font span{
  color: #ff2f4f;
  font-size: 20px;
  font-weight: 600;
}

.Item-right .el-input-number{
  width: 140px;
}
.tipSpan{
  text-align: right;
  font-size: 14px;
  color: #999999;
  margin-top: 10px;
  span:nth-child(2):hover{
    color: #4095e5;
  }
}
.cartNull{
  font-size: 20px;
  margin-top: 120px;
  line-height: 50px;
  color: #666666;
  text-align: center;
}
.cartNull .el-button{
  background: #f4a228;
  border: 1px solid #f4a228;
  color: #fff;
}
.MainInfo{
  position: relative;
}

.login {
  padding: 10px 10px;
  min-width: 900px;
  height: 800px;
  overflow: auto;
  position: fixed;
  font-size: 24px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  /* height: 900px;
  width: 700px; */
  /* border-radius: 0.25rem; */
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}
#pdfDom{
  width: 1300px;
  padding: 10px 10px;
  margin: 20px 20px 30px 20px;
}
.pdfButton{
  display: flex;
  justify-content: flex-end;
  margin: 10px 10px;
}
.descInfo{
  margin-top: 20px;
}

::v-deep .descInfo .el-descriptions-item__label{
  font-weight: 700 !important;
  color: #000;
}

@media screen and (min-width: 541px) {
  
  .list-Item{
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 20px;
    padding-left: 10px;
    border-bottom: 0.5px solid #f2f2f2;
    font-size: 20px;
  }
}
@media screen and (max-width: 540px) {
  .cartTop{
   
    align-items: center;
    margin-bottom: 20px;
  }
  .cartTop .title{
    font-size: 20px;
    margin-left: 10px;
    /* margin-bottom: 40px; */
  }
  .priceBottom .priceBox {
    /* width: 60%; */
    /* float: right; */
    width: 100%;
    font-size: 16px;
    padding-left: 0px;
    margin: 10px 8px 10px 0;
    
  }
  .priceBottom .priceBox span{
    font-size: 20px;
    /* margin-left: 10px; */
  }

  .list-Item{
    margin-top: 20px;
    display: block;
    padding-bottom: 20px;
    padding-left: 10px;
    border-bottom: 0.5px solid #f2f2f2;
    font-size: 18px;
  }

  
  .Item-left{
    margin-right: 10px;
  }
  .Item-left .left-font{
    margin-left: 20px;
    font-size: 17px;
  }
  .Item-right{
  
    text-align: right;
    margin-right: 10px;
    /* width: 140px; */
  }

}
</style>